export const normalizeLineBreaks = (text: string) => {
  const maxBreaks = 2;
  const regex = new RegExp(`\\n{${maxBreaks + 1},}`, 'g');
  return text.replace(regex, '\n'.repeat(maxBreaks));
};
